import { Box, ServiceLogo } from '@wishket/design-system';

import { MAIN_NAV_ITEMS } from './AppBar.constants';
import { GlobalNavigationLinkItem } from './parts';

import { Link } from '@/shared/Components';
import { PATH } from '@/shared/constants';

const MainMenu = () => {
  return (
    <Box className="flex items-center gap-6" data-testid="gnb-main-menu">
      <Link href={PATH.HOME} className="py-5" aria-label="Service Logo">
        <ServiceLogo name="yozmIT_symbol_text" />
      </Link>
      <Box className="hidden desktop:flex">
        <Box className="flex shrink-0 gap-2" data-testid="main-nav-root">
          {MAIN_NAV_ITEMS.map((item) => (
            <GlobalNavigationLinkItem
              key={item.href}
              href={item.href}
              isNew={item.isNew}
              hasAiLabel={item.hasAiLabel}
            >
              {item.label}
            </GlobalNavigationLinkItem>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default MainMenu;
